<template>
  <div>
    <div class="banner">
      <img src="@/assets/images/banner-ctv-1.png">
    </div>
    <div class="banner">
      <img src="@/assets/images/tai-app-415x315.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/images/banner2.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/images/360x520-1.jpg">
    </div>
    <div class="banner">
      <img src="@/assets/images/banner-chung-cu-pcc1-thanh-xuan.jpg">
    </div>

  </div>
</template>
<script>
export default {
  name: 'LeftNews'
}
</script>
<style lang="scss" scoped>
.news {
  overflow: hidden;

  .iframe-1 {
    border: 0;
    height: 1830px;
    margin-top: -100px;
    pointer-events: none;
    overflow: hidden;
  }
}

@media screen and (max-width: 600px) {
  .news {
    margin-top: 15px;
    .iframe-1 {
      //margin-top: -380px;
      height: 1840px;
    }
  }
}
</style>
